const ReactGA = require('react-ga')

const {
  hasAcceptedCookies,
  cookieAcceptEventName,
} = require('@mondough/cookie-opt-in')

const getUTMTrackingParamsFromUrl = (url) => {
  const { searchParams } = new URL(url)
  const utmParams = new Set([
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'utm_adgroup',
  ])

  for (const key of [...searchParams.keys()]) {
    if (!utmParams.has(key.toLowerCase())) searchParams.delete(key)
  }

  return searchParams.toString()
}

exports.onRouteUpdate = ({ location }) => {
  if (location.hash) {
    setTimeout(() => {
      document.querySelector(location.hash) &&
        document.querySelector(location.hash).scrollIntoView()
    }, 0)
  }
}

const _customTask = function() {
  // Function to set ClientId as Custom Dimension: https://www.notion.so/monzo/Adding-Client-ID-as-a-custom-dimension-b66119a094d346d19ccbcbb5ee90cc0c
  const clientIdIndex = 8

  const globalSendHitTaskName = '_ga_originalSendHitTask'

  return function(customTaskModel) {
    window[globalSendHitTaskName] =
      window[globalSendHitTaskName] || customTaskModel.get('sendHitTask')

    // clientIdIndex
    if (typeof clientIdIndex === 'number') {
      customTaskModel.set(
        'dimension' + clientIdIndex,
        customTaskModel.get('clientId'),
      )
    }
    // /clientIdIndex

    customTaskModel.set('sendHitTask', function(sendHitTaskModel) {
      const originalSendHitTaskModel = sendHitTaskModel,
        originalSendHitTask = window[globalSendHitTaskName],
        canSendHit = true

      try {
        if (canSendHit) {
          originalSendHitTask(sendHitTaskModel)
        }
      } catch (err) {
        originalSendHitTask(originalSendHitTaskModel)
      }
    })
  }
}

exports.onClientEntry = () => {
  const initializeGA = () => {
    ReactGA.initialize(
      process.env.GATSBY_GOOGLE_ANALYTICS_PROPERTY_ID || 'UA-63104269-4',
      {
        testMode: !!process.env.GATSBY_GOOGLE_ANALYTICS_TEST_MODE,
        gaOptions: { allowLinker: true },
      },
    )

    ReactGA.set({
      appName: 'Monzo Features',
    })
    ReactGA.ga('set', 'customTask', _customTask())
    ReactGA.ga('require', 'linker')
    ReactGA.ga('linker:autoLink', ['business.monzo.com'])
  }

  const initialCookieAccept = () => {
    initializeGA()
    const url = new URL(window.location.href)

    // If we have analytics permission, we can store UTM params in a session cookie
    const utmParams = getUTMTrackingParamsFromUrl(window.location.href)
    if (utmParams.length) {
      setCookie({ name: 'utmParams', value: encodeURIComponent(utmParams) })
    }

    // remove the query params so we don't send anything we shouldn't to GA.
    url.search = ''
    ReactGA.pageview(url.pathname)
  }

  if (hasAcceptedCookies('analytics')) {
    // If we have analytics permission, we can store UTM paramss in a session cookie
    const utmParams = getUTMTrackingParamsFromUrl(window.location.href)
    if (utmParams.length) {
      setCookie({ name: 'utmParams', value: encodeURIComponent(utmParams) })
    }
    initializeGA()
  }

  // Remove the eventListener first to ensure it is only ever set once
  window.removeEventListener(cookieAcceptEventName, initialCookieAccept)
  window.addEventListener(cookieAcceptEventName, initialCookieAccept, {
    once: true,
  })
}

exports.onRouteUpdate = (state) => {
  if (hasAcceptedCookies('analytics')) {
    const url = new URL(state.location.href)
    // remove the query params so we don't send anything we shouldn't to GA.
    url.search = ''
    ReactGA.pageview(url.pathname)
  }
}

const setCookie = ({
  name,
  value,
  expiryDays,
  domainOption = '.monzo.com',
}) => {
  if (typeof window !== 'undefined') {
    let expires = ''
    if (expiryDays != null) {
      const date = new Date()
      date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000)
      expires = 'expires=' + date.toUTCString() + ';'
    }
    const domain = 'domain=' + domainOption
    const sameSite = 'SameSite=Lax'
    const output =
      name +
      '=' +
      value +
      '; ' +
      expires +
      'path=/' +
      '; ' +
      domain +
      '; ' +
      sameSite
    document.cookie = output
  }
}
